<div class="container-fluid main-card">
    <div class="row">
        <div class="col-12">
            <h1>
                Historique
                <span>Consultez vos 20 dernières annonces</span>
            </h1>
        </div>
    </div>
    <div class="row">
        <div class="col-lg-12">
            <div class="card">
                <div class="card-body table-card">
                    <div [hidden]="this.favoritesList.favorites.length != 0 || loading == true" class="error-page">
                        <h3>Aucune annonce enregistrée</h3>
                        <img class="img-fluid" src="assets/illustrations/undraw_web_search_eetr.svg"><br/>
                    </div>
                    <mat-spinner color="second" [hidden]="!loading"></mat-spinner>
                    <table [hidden]="this.favoritesList.favorites.length == 0" mat-table [dataSource]="dataSource">
                        <ng-container matColumnDef="title">
                            <th mat-header-cell *matHeaderCellDef>Titre</th>
                            <td mat-cell *matCellDef="let element"> {{element.title}}</td>
                        </ng-container>

                        <ng-container matColumnDef="price">
                            <th mat-header-cell *matHeaderCellDef>Prix</th>
                            <td mat-cell *matCellDef="let element"> {{element.price | number: '1.0-0' }} €</td>
                        </ng-container>

                        <ng-container matColumnDef="ad_city.name">
                            <th class="hide-mobile" mat-header-cell *matHeaderCellDef>Ville</th>
                            <td class="hide-mobile" mat-cell
                                *matCellDef="let element"> {{element.ad_city.name}} </td>
                        </ng-container>

                        <ng-container matColumnDef="ad_city.zip_code">
                            <th class="hide-mobile" mat-header-cell *matHeaderCellDef>Code postal</th>
                            <td class="hide-mobile" mat-cell
                                *matCellDef="let element"> {{element.ad_city.zip_code}} </td>
                        </ng-container>

                        <ng-container matColumnDef="action">
                            <th mat-header-cell *matHeaderCellDef> Action</th>
                            <td mat-cell *matCellDef="let element">
                                <a *ngIf="element.favorite_list.id" class="btn btn-outline-primary btn-sm"
                                   [routerLink]="['/app/favorites', element.favorite_list.id, element.id]">
                                    <i class="fa fa-eye"></i> Détail
                                </a>
                                <a *ngIf="!element.favorite_list.id" class="btn btn-outline-primary btn-sm"
                                   [routerLink]="['/app/annonces', element.id]">
                                    <i class="fa fa-eye"></i> Détail
                                </a>
                            </td>
                        </ng-container>

                        <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
                        <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
                    </table>
                </div>
            </div>
        </div>
    </div>
</div>
